/**
 * Atalho para `window.location.href`
 * @param url URL que redirecionado
 */
export function redirectTo(url: string): void {
    (window as Window).location.href = url;
  }

  /**
   * Atalho para `encodeURIComponent()`
   * @param uri Algo que precisa de ser codificado
   */
export function urlEncode(uri: string): string {
    return encodeURIComponent(uri);
  }

  /**
   * Atalho para `decodeURIComponent()`
   * @param uri Algo que precisa de ser decodificado
   */
export function urlDecode(uri: string): string {
    return decodeURIComponent(uri);
  }


  /**
   * Atalho para comparar Objetos.
   * @param obj1 Objeto 1 de comparação
   * @param obj2 Objeto 2 de comparação
   */
export function compareObjects(obj1: any = {}, obj2: any = {}): boolean {
    if (typeof obj1 !== typeof obj2) {
      return false;
    }

    if (obj1 === obj2) {
      return true;
    }

    const o1 = obj1 || {};
    const o2 = obj2 || {};

    if (typeof o1 !== 'object' || typeof o2 !== 'object') {
      return false;
    }

    function fnLength(o: any): number {
      return Object.keys(o).length;
    }

    if (fnLength(o1) !== fnLength(o2)) {
      return false;
    }

    return Object.keys(o1).every((key: string) => compareObjects(o1[key], o2[key]));
  }

  /**
   * Atalho para comparar objeto em lista
   * @param list Lista de objetos
   * @param obj Objeto
   */
export function checkObjectInList({ list, obj }: { list: any[]; obj: any; }): boolean {
    return list.some(
      (item: any) => compareObjects(item, obj)
    );
  }

export function verificaSexo(sexo) {
    switch (sexo) {
        case 'Masculino':
            return 'M';
        case 'M':
            return 'Masculino';
        case 'Feminino':
            return 'F';
        case 'F':
            return 'Feminino';
        case 'Ignorado':
            return 'I';
        case 'I':
            return 'Ignorado';
    }
}
